import React, { FunctionComponent } from 'react';
import { useFlags } from '../../hooks';
import LeaderboardFundraisersList from './LeaderboardFundraisersList';
import LegacyFundraisersList from './LegacyFundraisersList';

const FundraisersList: FunctionComponent = () => {
  const flags = useFlags();

  return flags.useLeaderboarFundraisersList ? (
    <LeaderboardFundraisersList />
  ) : (
    <LegacyFundraisersList />
  );
};

export default FundraisersList;
